module.exports = __webpack_public_path__ + "img/jigou.06e157cc.png";